import { Image } from 'react-frontier';
import { CDN_URL } from '../ConfigPublic';

import '../style/footer.scss'

var Footer = () => {
   return <div className='co footer'>
      <div className="flex">
         <Image src={`${CDN_URL}/static/logo/Logo_Full_White.png`} alt='Logo' className="logo" height={45} />
         <div className="left">
            <div className="sections">
               <div className="section">
                  <a href="/visitanos" className="header">SUCURSALES</a>
                  <a href="/visitanos" className="item">Río Manzanares</a>
                  <a href="/visitanos" className="item">Río De la Plata</a>
               </div>
               <div className="section">
                  <div className="header">ACERCA DE</div>
                  <a href="/nosotros" className="item">Nosotros</a>
                  <a href="/vacantes" className="item">Bolsa de trabajo</a>
                  <a href="/ordenes" className="item">Ordenes</a>
                  <a href="/ayuda" className="item">Ayuda + FAQ</a>
               </div>
               <div className="section">
                  <div className="header">LEGALES</div>
                  <a href="/facturar" className="item">Facturación</a>
                  <a href="/terminos" className="item">Términos y condiciones</a>
               </div>
               <div className="section">
                  <div className="header">SÍGUENOS</div>
                  <a href="https://www.facebook.com/cocoanchocolateria/" className="item" target="_blank" rel="noopener noreferrer">
                     <i className="facebook square icon"></i>
                     /cocoanchocolateria
                  </a>
                  <a href="https://www.instagram.com/cocoanchocolateria/" className="item" target="_blank" rel="noopener noreferrer">
                     <i className="instagram icon"></i>
                     @cocoanchocolateria
                  </a>
                  <a
                     className="item"
                     href={`https://wa.me/528129448353?text=%C2%A1Hola!%20Vengo%20de%20la%20p%C3%A1gina%2C%20me%20gustar%C3%ADa%20tener%20m%C3%A1s%20informaci%C3%B3n.`}
                     target='_blank'
                     rel='noopener noreferrer'
                  >
                     <i className="whatsapp icon"></i>
                     WhatsApp
                  </a>
               </div>
            </div>
         </div>
      </div>
   </div>
}

export default Footer;
